export type AssistantRuntimePolicyReason =
  | 'assistant_enabled'
  | 'assistant_disabled_by_policy';

export type AssistantRuntimePolicy = {
  enabled: boolean;
  reason: AssistantRuntimePolicyReason;
};

const normalizePathname = (value: string | null | undefined): string => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) {
    return '/';
  }
  const withoutQuery = trimmed.split('?')[0] ?? trimmed;
  const normalized = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  return normalized.toLowerCase();
};

const normalizePersona = (value: string | null | undefined): string =>
  String(value ?? '').trim().toLowerCase().replace(/[\s_]+/g, '-');

const isParentRoutePath = (pathname: string): boolean => (
  pathname.startsWith('/parent/portal/')
  || pathname === '/parent/portal'
  || pathname.startsWith('/parent/portal--new/')
  || pathname === '/parent/portal--new'
  || pathname.startsWith('/portal/family/')
  || pathname === '/portal/family'
);

const isAttendanceRoutePath = (pathname: string): boolean => (
  pathname === '/school/attendance'
  || pathname.startsWith('/school/attendance/')
  || pathname === '/super-administrator/control-plane/attendance'
  || pathname.startsWith('/super-administrator/control-plane/attendance/')
);

const isAttendanceControlPlaneRoutePath = (pathname: string): boolean => (
  pathname === '/super-administrator/control-plane/attendance'
  || pathname.startsWith('/super-administrator/control-plane/attendance/')
);

export const getAssistantRuntimePolicy = (input: {
  pathname?: string | null;
  persona?: string | null;
}): AssistantRuntimePolicy => {
  const pathname = normalizePathname(input.pathname);
  const persona = normalizePersona(input.persona);
  const isParentPersona = persona === 'parent';
  const isAttendanceDeniedPersona = persona === 'nurse' || persona === 'viewer' || persona === 'parent';
  const isAttendanceControlPlaneDeniedPersona = isAttendanceControlPlaneRoutePath(pathname) && persona !== 'super-administrator';

  if (
    isParentPersona
    || isParentRoutePath(pathname)
    || (isAttendanceRoutePath(pathname) && isAttendanceDeniedPersona)
    || isAttendanceControlPlaneDeniedPersona
  ) {
    return {
      enabled: false,
      reason: 'assistant_disabled_by_policy',
    };
  }

  return {
    enabled: true,
    reason: 'assistant_enabled',
  };
};
